import { ToastMessage } from 'primereact/toast';

/**
 * Shows global toasts from anywhere, including plain JS/TS. Needs ToastProvider with
 * GlobalToastInitializer; otherwise `show` only warns. Pass `closable: true` for a close button.
 *
 * @example
 * globalToastService.show({ severity: 'success', summary: 'Success', detail: 'Done' });
 */

type GlobalToastApi = {
  show: (message: ToastMessage | ToastMessage[]) => void;
  remove: (message: ToastMessage | ToastMessage[]) => void;
};

let toastApi: GlobalToastApi | null = null;

export const setGlobalToastApi = (api: GlobalToastApi) => {
  toastApi = api;
};

export const globalToastService = {
  show: (message: ToastMessage | ToastMessage[]) => {
    if (!toastApi) {
      // Warn only in development to avoid leaking info in production
      if (process.env.NODE_ENV !== 'production') {
        console.warn('[globalToastService] GlobalToastInitializer is not mounted. Toast messages will not be shown.');
      }
      return;
    }
    toastApi.show(message);
  },
  /** Closes a toast shown earlier; pass the same message object that was shown. */
  remove: (message: ToastMessage | ToastMessage[]) => {
    toastApi?.remove(message);
  },
};
